/** Homepage graphics only: never apply this to inventory/unit photos. */
export const HOMEPAGE_CDN_BASE = "https://www.myrvpart.com/images/splash-assets";
const STORAGE_BASE = "https://cpkvmigljcrjxctoixoq.supabase.co/storage/v1/object/public/splash-assets";

export function homepageCdnImage(src: string): string {
  if (src.startsWith("/images/splash-assets/")) {
    return HOMEPAGE_CDN_BASE + src.slice("/images/splash-assets".length).split("?")[0];
  }
  if (src.startsWith(STORAGE_BASE + "/")) {
    return HOMEPAGE_CDN_BASE + src.slice(STORAGE_BASE.length).split("?")[0];
  }
  return src;
}

/** Preserve the original storage copy when an already-CDN URL fails. */
export function homepageImageBackup(src: string): string {
  return src.startsWith(HOMEPAGE_CDN_BASE + "/")
    ? STORAGE_BASE + src.slice(HOMEPAGE_CDN_BASE.length)
    : src;
}

/** Also called when the ref attaches: an image may fail before hydration. */
export function recoverHomepageImage(image: HTMLImageElement, backup: string) {
  if (image.dataset['imageBackup'] === "1") return;
  image.dataset['imageBackup'] = "1";
  image.parentElement?.querySelector("source")?.removeAttribute("srcset");
  image.src = backup;
}